import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import classNames from 'classnames';
export const Tabs = ({ data, defaultSelected, type, className, onChange, onChangeMultiSelector, multiSelector, isWrap = true, isDesktop, buttonsFullWidth, lessPadding, variant }) => {
    const [selected, setSelected] = useState(defaultSelected || [data[0]?.label]);
    const isPill = type === 'pill';
    const isLine = type === 'line';
    const isBar = type === 'bar';
    const isDark = variant === 'dark';
    const isBlue = variant === 'blue';
    const getButtonClassName = (tab) => {
        return classNames('group flex items-center justify-center gap-2 whitespace-nowrap font-semibold', {
            'text-sm px-4 py-1.5 rounded-full': isPill,
            'text-base py-4 px-3 border-b-2': isLine,
            'text-sm py-[7px] rounded-full border border-gray md:border-transparent': isBar,
            'px-3': isBar && lessPadding,
            'px-4': isBar && !lessPadding,
            'border-transparent': isBar && isDesktop && !variant,
            relative: !!tab.badge,
            grow: buttonsFullWidth
        }, isBlue && {
            'text-white bg-primary-400': selected.includes(tab.label),
            'text-gray': !selected.includes(tab.label),
            'text-gray-300 cursor-not-allowed': tab.disabled
        }, isDark && {
            'text-white bg-primary-900 border-transparent': selected.includes(tab.label),
            'border text-gray border-gray': isPill,
            'hover:enabled:border-gray-600 hover:enabled:text-gray-600': !selected.includes(tab.label),
            'text-gray-300 border-gray-300 cursor-not-allowed': tab.disabled
        }, isPill &&
            !variant &&
            (selected.includes(tab.label)
                ? 'bg-secondary text-white hover:bg-secondary-600'
                : data[0]?.color
                    ? 'text-primary bg-gray-100 hover:bg-gray-200'
                    : 'text-gray bg-gray-100 hover:bg-gray-200'), isLine &&
            !variant &&
            (selected.includes(tab.label)
                ? 'border-secondary text-secondary'
                : 'border-transparent text-gray hover:text-secondary'), isBar &&
            !variant &&
            (selected.includes(tab.label)
                ? 'bg-secondary-100 text-secondary-600 border-secondary-100'
                : 'text-gray hover:text-gray-400 md:hover:text-secondary'));
    };
    const redDotClassNames = classNames('absolute right-2.5 w-1 h-1 rounded-xl bg-red-500', isLine ? 'top-5' : 'top-2');
    const getCounterClassNames = (val, isUrgent) => {
        return classNames('rounded-xl px-2 py-0.5 font-bold text-xs -ml-1 text-white', { 'bg-red-500': isLine }, isBar &&
            (selected.includes(val)
                ? 'bg-secondary-600'
                : `${isUrgent ? 'bg-red-500' : 'bg-gray'} group-hover:bg-gray-400 md:group-hover:bg-secondary`));
    };
    const getCircleClassName = (color) => {
        return classNames('w-2 h-2 border border-white rounded-full flex-none', color);
    };
    const onClick = (val) => {
        if (multiSelector) {
            setSelected((prev) => {
                let result;
                result = prev.includes(val.label)
                    ? prev.filter((item) => item !== val.label)
                    : [...prev, val.label];
                if (!result.length || val.label === data[0]?.label) {
                    result = [data[0]?.label];
                }
                else if (result.length > 1) {
                    result = result.filter((item) => item != data[0]?.label);
                }
                onChangeMultiSelector &&
                    onChangeMultiSelector(data.filter((item) => result.includes(item.label)));
                return result;
            });
        }
        else {
            setSelected([val.label]);
            onChange && onChange(val);
        }
    };
    const wrapperClassName = classNames('flex w-fit overflow-auto', {
        'gap-2': isPill,
        'gap-2 md:gap-0': isBar,
        'flex-wrap': isWrap
    }, className);
    useEffect(() => {
        if (defaultSelected) {
            setSelected(defaultSelected);
        }
    }, [defaultSelected]);
    return (_jsx("div", { className: wrapperClassName, "data-testid": "tabs_filter_menu", children: data.map((el) => (_jsxs("button", { disabled: el.disabled, className: getButtonClassName(el), type: "button", onClick: () => onClick(el), children: [isPill && el.color && _jsx("div", { className: getCircleClassName(el.color) }), el.label, el.badge &&
                    ('count' in el ? (_jsx("span", { className: getCounterClassNames(el.label, el.isUrgent), children: el.count })) : (_jsx("div", { className: redDotClassNames }))), !el.badge && 'count' in el && ` (${el.count})`] }, el.label))) }));
};
